import React from 'react';

const TitDer = ({textBoton1, list, styles, handleClick, btnNuevo = "SI"}) => {
  // (list) ? console.log(list.length) : console.log("0")
    return(
      <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="yellow icon" style={styles.titBuscarTot}>{(list) ? list.length : ""}</i>
          {textBoton1}
      </button>

      {btnNuevo==="SI" &&
      <button className="ui right labeled icon button" onClick={handleClick} style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Nuevo
      </button>
      }
    </div>  )
  }

export default TitDer